export const urlPrefix = () => {
  const needPrefix = window.location.href.indexOf('needPrefix') > -1;
  const { hostname } = window.location;
  return (hostname.indexOf('shaanxi') > -1 || hostname === '59.218.152.128' || needPrefix) ? '/recept' : ''
}

export const transformUrl = (url) => {
  const regex = /^https?:\/\//i; // 字符串是否以"http://"或"https://"开头
  if (regex.test(url)) {
    return url;
  }
  return urlPrefix() + url;
}

const getHashParams = () => {
  const hash = window.location.hash;
  const paramsString = hash.split('?')[1] || '';
  const params = paramsString.split('&').reduce((acc, param) => {
    const [key, value] = param.split('=');
    acc[key] = decodeURIComponent(value);
    return acc;
  }, {});

  return params || {};
}

// “下一步”按钮添加参数
export const submitExtraParams = () => {
  const { hostname, search } = window.location;
  const queryParams = new URLSearchParams(search);
  const local = queryParams.get('local') || getHashParams().local || ''; // 本地开发调试
  const subOrderId = queryParams.get('subOrderId') || getHashParams().subOrderId || '';
  // 广西
  if ((hostname.indexOf('gxzf') > -1 || hostname === '121.43.34.55' || local === 'gx') && subOrderId) {
    return {
      subOrderId
    }
  }
  return {};
}